import { t } from 'i18next';
import { useStateStorage } from 'store/state';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';
import Button from '../button/Button';
import './CookiesPopup.scss';

const CookiesPopup = () => {
  const { cookiesAccepted, setCookiesAccepted } = useStateStorage();
  return cookiesAccepted ? null : (
    <div className='cookies-popup'>
      {/* <PiCookie /> */}
      <p>{t('public-page.cookies-description')}</p>
      <Button onClick={setCookiesAccepted} variant={BUTTON_VARIANT.submit}>
        <Button.Text text={t('public-page.cookies-accept')} />
      </Button>
    </div>
  );
};

export default CookiesPopup;
